import { useEffect, useState } from "react";
import { CookiesProvider } from "react-cookie";
import "./App.css";

import PhysioRouter from "./PhysioRouter";
import { UnloggedDoctor } from "./auth/interfaces";
import { SignedInContext } from "./AppEnv";

import { ConfigProvider } from "antd";
import itIT from "antd/lib/locale/it_IT";
import "moment/locale/it";
import Chat from "./assistente/chat";
import PhysioChat from "./chat/PhysioChat";

function App() {
  const [signedInDoctor, setSignedInDoctor] = useState(UnloggedDoctor);
  console.log('signedInDoctor:', signedInDoctor);
  return (


    
    <ConfigProvider locale={itIT}>
      <CookiesProvider>
        <SignedInContext.Provider
          value={{
            signedInDoctor,
            setSignedInDoctor,
          }}
        >
            {signedInDoctor && signedInDoctor.id !== -1 ? (
            <>
            
<PhysioChat />

            </>
          ): null}
          <PhysioRouter />
        </SignedInContext.Provider>
      </CookiesProvider>
    </ConfigProvider>
  );
}

export default App;
